import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";

function PipelineDelete(props) {
  const { onDelete, onClose, pipeline, loading } = props;

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Delete {pipeline?.name}?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onDelete} loading={loading}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PipelineDelete;
